import { Button, Text } from '@blueprintjs/core'
// TODO - Documentar
import { useEffect, useState } from 'react'
import * as con from "../../GlobalConstants"
import { useDispatch } from 'react-redux'
import { finalPage, firstPage, nextPage, previousPage } from '../../store/slices/transactionsSlice'
import { getTotalTransactionPages } from '../../utils/transactionFunctions'
import { RefTransactionsHook } from '../hooks/TransactionsHooks'



function TransactionTableNavegation({ forcedSelectedTransaction }) {

    const selectedTransactions = RefTransactionsHook(con.SELECTED_TRANSACTIONS)
    const currentNavegationPage = RefTransactionsHook(con.CURRENT_TRANSACTION_NAVIGATION_PAGE)
    const totalTransactionsBeingDisplayed = RefTransactionsHook(con.TOTAL_TRANSACTIONS_DISPLAYED)
    const dispatch = useDispatch()

    // Local Transactions
    const [localSelectedTransactions, setLocalSelectedTransactions] = useState(() => forcedSelectedTransaction !== null && forcedSelectedTransaction !== undefined ? forcedSelectedTransaction : selectedTransactions)
    
    useEffect(() => {
      
      if(forcedSelectedTransaction === null || forcedSelectedTransaction === undefined)
        setLocalSelectedTransactions(selectedTransactions)


    }, [selectedTransactions, forcedSelectedTransaction])
    

    // Loading
    // Transactions Loaded
    const transStatus = RefTransactionsHook(con.TRANSACTIONS_LOADED)
    // Loading
    const loading = RefTransactionsHook(con.LOADING_CURRENT_TRANSACTIONS)


  return (  
    <div>
      { getTotalPages(localSelectedTransactions, totalTransactionsBeingDisplayed) > 0 &&
        transStatus[localSelectedTransactions] === con.OK &&
        !loading &&

      <div className="line-arrangement">      
          <Button icon={"double-chevron-left"} minimal={true} onClick={ ()=> dispatch(firstPage(localSelectedTransactions))}/>
          <Button icon={"chevron-left"} minimal={true} onClick={ ()=> dispatch(previousPage(localSelectedTransactions))}/>
          <Text>Pagina {currentNavegationPage[localSelectedTransactions] + 1} de {getTotalPages(localSelectedTransactions, totalTransactionsBeingDisplayed) + 1}</Text>
          <Button icon={"chevron-right"} minimal={true} onClick={ ()=> dispatch(nextPage(localSelectedTransactions))}/>
          <Button icon={"double-chevron-right"} minimal={true} onClick={ ()=> dispatch(finalPage(localSelectedTransactions))}/>  
      </div>
      }
    </div>
  )
}

TransactionTableNavegation.defaultProps = {
  forcedSelectedTransaction : null
}

export default TransactionTableNavegation

const getTotalPages = (selectedTransactions, totalTransactions) =>
{
    return(getTotalTransactionPages(totalTransactions[selectedTransactions]))
}